<template>
    <div>
        <card-header title="Editor" icon="fa-edit"/>

        <card-toolbar>
            <button @click="$openCard('edit-component', {componentId: component.id}, card)"><i class="far fa-pencil"></i>Edit Component</button>
            <button @click="duplicate"><i class="far fa-copy"></i>Duplicate</button>
        </card-toolbar>

        <card-body>
            <div id="editorjs" class="content"></div>
        </card-body>

        <card-footer class="pt-3 pb-3 has-text-right">
            <b-button type="is-primary" size="is-small" @click="submit">
                <i class="fas fa-check mr-2"></i>Save
            </b-button>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardList from "@/TIER/components/CardList";
    import NavigationListItem from "@/TIER/components/NavigationListItem";
    import CardContainer from "@/TIER/components/CardContainer";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import SeparatorListItem from "@/TIER/components/SeparatorListItem";
    import DataRow from "@/TIER/components/DataRow";
    import ContainerListItem from "@/TIER/components/ContainerListItem";
    import CardFooter from "@/TIER/components/CardFooter";

    import {client as http, apiUrl} from '../../http_client';

    const axios = require('axios');
    import {mapGetters} from 'vuex';

    import EditorJS from "@editorjs/editorjs";
    import Paragraph from '@editorjs/paragraph';//TODO not working
    import Header from '@editorjs/header';
    import Embed from '@editorjs/embed';
    import Table from '@editorjs/table';
    import Marker from '@editorjs/marker';
    import Quote from '@editorjs/quote';
    import Underline from '@editorjs/underline';
    import Warning from '@editorjs/warning';
    import ImageTool from '@editorjs/image';
    import NestedList from '@editorjs/nested-list';
    import CheckList from '@editorjs/checklist';
    import Attaches from '@editorjs/attaches';

    import UserInput from '@/components/editorjs/UserInput';
    import ComponentReview from '@/components/editorjs/ComponentReview';
    import Delimiter from '@/components/editorjs/Delimiter';
    import QuizQuestion from '@/components/editorjs/QuizQuestion';
    import QuizMultiple from '@/components/editorjs/QuizMulti';
    import FontSize from 'editorjs-inline-font-size-tool';
    import FontFamily from 'editorjs-inline-font-family-tool';
    import TextColor from '@/components/editorjs/TextColor';

    import AlignmentTuneTool from 'editorjs-text-alignment-blocktune';

    let token = null;

    export default {
        components: {CardFooter, ContainerListItem, DataRow, SeparatorListItem, CardToolbar, CardContainer, NavigationListItem, CardList, CardBody, CardHeader},
        props: ['card', 'props', 'child'],
        data() {
            return {
                component: {},
                content: {},
            };
        },
        computed: {
            ...mapGetters(['token'])
        },
        methods: {
            loadComponent: function() {
                if (window.editor && window.editor.destroy) window.editor.destroy();

                this.$emit('loading', true);
                http.get('components/' + this.props.componentId, {force: true}).then(response => {
                    this.component = response.data;
                    this.$emit('loading', false);

                    window.editor = new EditorJS({
                        holder: 'editorjs',
                        placeholder: 'Add component content...',
                        defaultBlock: 'paragraph',
                        inlineToolbar: ['bold', 'italic', 'underline', 'marker', 'color', 'fontSize', 'fontFamily', 'link'],
                        tools: {
                            header: {
                                class: Header,
                                config: {
                                    placeholder: 'Enter a header',
                                    levels: [1, 2, 3, 4, 5, 6],
                                    defaultLevel: 3,
                                },
                                inlineToolbar: true,
                                tunes: ['alignTune']
                            },
                            // INLINE
                            marker: Marker,
                            underline: Underline,
                            color: {
                                class: TextColor,
                                config: {
                                    colorCollections: ['#FF1300', '#EC7878', '#9C27B0', '#673AB7', '#3F51B5', '#0070FF', '#03A9F4', '#00BCD4', '#4CAF50', '#8BC34A', '#CDDC39', '#000', '#4a4a4a', '#666', '#999'],
                                    defaultColor: '#4a4a4a',
                                    type: 'text',
                                }
                            },
                            fontSize: FontSize,
                            fontFamily: FontFamily,
                            // BLOCKS
                            paragraph: {
                                class: Paragraph,
                                inlineToolbar: true,
                                tunes: ['alignTune']
                            },
                            quote: Quote,
                            table: {
                                class: Table,
                                inlineToolbar: true
                            },
                            list: {
                                class: NestedList,
                                inlineToolbar: true,
                            },
                            checklist: {
                                class: CheckList,
                                inlineToolbar: true,
                            },
                            delimiter: Delimiter,
                            embed: {
                                class: Embed,
                                config: {
                                    services: {
                                        youtube: true,
                                        vimeo: true
                                    }
                                }
                            },
                            image: {
                                class: ImageTool,
                                config: {
                                    uploader: {
                                        uploadByFile(file) {
                                            let formData = new FormData();
                                            formData.append('image', file);
                                            return axios.post(apiUrl + 'components/image/data', formData, {
                                                headers: {
                                                    'Authorization': token,
                                                    'Content-Type': 'multipart/form-data'
                                                }
                                            }).then(response => {
                                                return response.data;
                                            }).catch(() => {
                                                return {success: 0};
                                            });
                                        },
                                        uploadByUrl(url) {
                                            return http.post('components/image/url', {url}).then(response => {
                                                return response.data;
                                            });
                                        }
                                    }
                                }
                            },
                            warning: {
                                class: Warning,
                                inlineToolbar: true,
                                config: {
                                    titlePlaceholder: 'Title',
                                    messagePlaceholder: 'Message',
                                },
                            },
                            attaches: {
                                class: Attaches,
                                config: {
                                    endpoint: (location.hostname === 'portal.my247ed.com') ? 'https://api.my247ed.com/portal/components/file/data'
                                    : ((location.hostname === 'localhost')
                                    ? 'http://localhost:3000/portal/components/file/data'
                                    : 'https://api.my247ed.lan/portal/components/file/data')
                                }
                            },
                            // DATA
                            userInput: {
                                class: UserInput
                            },
                            componentReview: {
                                class: ComponentReview
                            },
                            // QUIZ
                            quizQuestion: {
                                class: QuizQuestion
                            },
                            quizMultiple: {
                                class: QuizMultiple
                            },
                            //
                            // TUNES
                            alignTune: {
                                class: AlignmentTuneTool,
                                config: {
                                    default: "left",
                                    blocks: {
                                        paragraph: 'left',
                                        header: 'left',
                                        list: 'left'
                                    }
                                },
                            }
                        },
                        onReady: () => {

                        },
                        onChange: () => {
                            this.$saveAlert(true, 'Are you done editing this component? Unsaved changes will be lost.');
                        },
                        data: JSON.parse(this.component.content) // TODO this bugs out if you refresh the site with this card open
                    });

                });
            },
            submit() {
                this.$emit('loading', true);
                window.editor.save().then(saved => {
                    this.component.content = JSON.stringify(saved);
                    http.put('components/' + this.props.componentId, this.component, {force: true}).then(response => {
                        this.$saveAlert(false);
                        this.$closeCard(this.card);
                    });
                });
            },
            duplicate: function() {
                this.$emit('loading', true);
                window.editor.save().then(saved => {
                    this.component.content = JSON.stringify(saved);
                    http.put('components/' + this.props.componentId, this.component, {force: true}).then(response => {
                        http.post('components/duplicate', {id: this.component.id}).then(response => {
                            this.$reloadCard('components');
                            this.$saveAlert(false);
                            this.$closeCard(this.card);
                        });
                    });
                });
            }
        },
        watch: {
            'props.componentId': function() {
                this.loadComponent();
            }
        },
        mounted: function() {
            this.loadComponent();
            token = this.token; // More global scope for editor posts
        },
        destroyed() {
            window.editor.destroy();
        }
    };
</script>

<style lang="scss">
    #editorjs {
        margin-top: 20px;
    }

    h4 {
        font-size: 2rem;
    }

    svg.icon {
        width: 14px !important;
        height: 14px !important;

        align-items: normal;
        display: inline;
        justify-content: normal;
    }

    .ce-block__content,
    .ce-toolbar__content {
        max-width: 887px;
    }

    .ce-toolbox {
        li:first-child {
            margin-top: 0.25em;
        }
    }

    .ce-block {
        border-left: 0.4rem solid #d9d9d9;
        margin: 0.6rem 0;

        &.ce-block--focused {
            border-color: #336699;
        }

        &.ce-block--stretched {
            border-right: 0.4rem solid white;
        }

        table {
            margin-bottom: 0 !important;

            td {
                padding: 0 !important;
                border-width: 1px !important;
            }

        }

        .tc-table__wrap {
            margin: 2rem 0;
        }
    }

    .cdx-block {
        padding: 0;
    }

</style>
